import React from "react"
import styled from "styled-components"
import {useHistory} from "react-router-dom"
import {useDispatch, useSelector} from "react-redux"
// UI
import {Container, Grid, Row, Col} from "@uprise/grid"
import {TextInputHorizontal} from "@uprise/form"
import {H4, H6} from "@uprise/headings"
import {P} from "@uprise/text"
import {Button} from "@uprise/button"
// Slices
import {clearNewUserApiState} from "../../usersSlice"
import success from "assets/images/svg/success.svg"

const PageContainer = styled(Container)``

const Heading = styled(H4)`
	text-align: center;
`

const SubHeading = styled(H6)`
	text-align: center;
`

const ImageFigure = styled.figure`
	text-align: center;
`

const CloseButton = styled(Button)`
	width: 100%;
	max-width: 200px;
	margin: auto;
`

const SuccessPage = () => {
	const dispatch = useDispatch()
	return (
		<PageContainer className='m-t-10 m-b-10'>
			<Heading>Success</Heading>
			<ImageFigure>
				<img src={success} alt={""} />
			</ImageFigure>

			<SubHeading data-testid="userCreateSuccess" >User has been created successfully</SubHeading>

			<CloseButton
				title={"Make another"}
				onClick={() => {
					dispatch(clearNewUserApiState())
				}}
			/>
		</PageContainer>
	)
}

export default SuccessPage
